import {ISimpleSubStep} from './types';

export const STEPS: ISimpleSubStep[] = ['build', 'summary'];